const STORAGE_KEY = 'product_split_data';

class ProductSplitService {
  constructor() {
    this.cache = this.loadFromStorage();
  }

  loadFromStorage() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : {};
    } catch (error) {
      return {};
    }
  }

  saveToStorage() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.cache));
    } catch (error) {
      console.error('Failed to save split data:', error);
    }
  }

  getKey(customerId, productId) {
    return `${customerId}_${productId}`;
  }

  storeSplitData(customerId, productId, productData) {
    const key = this.getKey(customerId, productId);
    const existingData = this.cache[key] || {};
    
    this.cache[key] = {
      product_id: productId,
      customer_id: customerId,
      split: productData.split || "1",
      sales_box_price: productData.price || productData.final_price || productData.sales_box_price || "0",
      sales_piece_price: productData.split_price || productData.final_split_price || productData.sales_piece_price || "0",
      noOfPieceInBox: productData.noOfPieceInBox || "1",
      product_code: productData.product_code || productData.code || "",
      product_name: productData.product_name || productData.name || "",
      tax_rate: productData.tax_rate || productData.rate || "0",
      defaultOrderType: existingData.defaultOrderType || productData.order_type || (productData.split === "1" ? "Piece" : "Box"),
      updated_at: new Date().toISOString()
    };
    
    this.saveToStorage();
    return this.cache[key];
  }

  setDefaultOrderType(customerId, productId, orderType) {
    const key = this.getKey(customerId, productId);
    if (this.cache[key]) {
      this.cache[key].defaultOrderType = orderType;
      this.cache[key].updated_at = new Date().toISOString();
      this.saveToStorage();
    }
  }

  getDefaultOrderType(customerId, productId) {
    const data = this.getSplitData(customerId, productId);
    return data?.defaultOrderType || null;
  }

  getSplitData(customerId, productId) {
    const key = this.getKey(customerId, productId);
    return this.cache[key] || null;
  }

  canSplit(customerId, productId) {
    const data = this.getSplitData(customerId, productId);
    return data && data.split === "2";
  }

  getPrice(customerId, productId, type) {
    const data = this.getSplitData(customerId, productId);
    if (!data) return null;
    
    return type === "Box" ? data.sales_box_price : data.sales_piece_price;
  }

  clearProductType(customerId, productId) {
    const key = this.getKey(customerId, productId);
    if (this.cache[key]) {
      delete this.cache[key].defaultOrderType;
      if (Object.keys(this.cache[key]).length <= 2) {
        delete this.cache[key];
      } else {
        this.cache[key].updated_at = new Date().toISOString();
      }
      this.saveToStorage();
    }
  }

  clearCustomerData(customerId) {
    Object.keys(this.cache).forEach(key => {
      if (key.startsWith(`${customerId}_`)) {
        delete this.cache[key];
      }
    });
    this.saveToStorage();
  }

  clearAll() {
    this.cache = {};
    localStorage.removeItem(STORAGE_KEY);
  }

  cleanOldData(daysOld = 7) {
    const cutoffDate = new Date();
    cutoffDate.setDate(cutoffDate.getDate() - daysOld);
    
    Object.keys(this.cache).forEach(key => {
      const item = this.cache[key];
      if (item.updated_at && new Date(item.updated_at) < cutoffDate) {
        delete this.cache[key];
      }
    });
    
    this.saveToStorage();
  }
}

const productSplitService = new ProductSplitService();

export default productSplitService;

